//import loggingService from '@/services/util/loggingService'

//var serviceName = 'ReportService'
var path = '/Report/'
//var isDebug = false

function shpoAnnualReportData (http, filterDto) {
    return http.post(path + `ShpoAnnualReportData`, filterDto)
}

function shpoAnnualReportDataCsv (http, filterDto) {
    return http.post(path + `ShpoAnnualReportDataCsv`, filterDto)
}

function shpoPrehistoricSnrReportData (http, filterDto) {
    return http.post(path + `ShpoPrehistoricSnrReportData`, filterDto)
}

function shpoPrehistoricSnrReportDataCsv (http, filterDto) {
    return http.post(path + `ShpoPrehistoricSnrReportDataCsv`, filterDto)
}

export default {
    shpoAnnualReportData: shpoAnnualReportData,
    shpoAnnualReportDataCsv: shpoAnnualReportDataCsv,
    shpoPrehistoricSnrReportData,
    shpoPrehistoricSnrReportDataCsv
}



// WEBPACK FOOTER //
// ./src/services/reportService.js